module.exports = __webpack_public_path__ + "img/s3-1-ja.20edc9ef.jpg";